import { Box, BoxProps, styled } from "@mui/material"
import { classes } from "@tm/utils"
import { LEFT_ROW_INDICATOR, ZINDEX_BASE } from "../configs"

type ExtendedTableCellProps = {
    active?: boolean
    colCount: number
    rowIndicatorColor?: string
}

function shouldForwardProp(prop: PropertyKey) {
    return !["theme", "colCount", "active", "rowIndicatorColor"].includes(prop as string)
}

export const ExtendedTableCell = styled(ExtendedTableCellComponent, { shouldForwardProp })<ExtendedTableCellProps>((props) => {
    const { theme, colCount, active, rowIndicatorColor } = props
    const elementListOverwrites = theme.overwrites?.components?.elementList ?? {}
    const overwritesBorderLeftWidth = elementListOverwrites?.backgroundColor?.borderLeftWidth
    const borderLeftWidth = overwritesBorderLeftWidth || LEFT_ROW_INDICATOR

    return {
        zIndex: ZINDEX_BASE,
        gridColumnStart: 1,
        gridColumnEnd: `span ${colCount}`,
        padding: theme.spacing(1.2, 2, 0, 2),
        display: "flex",
        borderLeft: `${active ? 1 : borderLeftWidth}px solid ${rowIndicatorColor || theme.palette.grey[300]}`,
        borderRight: `1px solid ${theme.palette.grey[200]}`,
    }
})

function ExtendedTableCellComponent(props: BoxProps) {
    const { className, children, ...rest } = props
    return (
        <Box className={classes("Table-extendedCell", "Table-cell", className)} {...rest}>
            {children}
        </Box>
    )
}
